var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"confirm-button",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.btnConfirm,"alt":"确定"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }